import ApiService from "../ApiService";

const appointmentService = {
    saveCalendarAppointment(data) {
        return ApiService.post(`/appointment/`, data);
    },

    inactive(date) {
        return ApiService.post(`/appointment/inactive/`, date);
    },
    branchAll() {
        return ApiService.get(`/branch/get-all-branch-for-appointment`);
    },
    statesAppointment(countryId) {
        countryId = countryId || 1;
        return ApiService.get(`/state/search-state-by-branch/${countryId}`);
    },
    cityAppointment(cityId) {
        cityId = cityId || 1;
        return ApiService.get(`/city/by-state-branch/${cityId}`);
    },

    getBranchesAppointment(idBranch) {
        return ApiService.get(
            `/branch/get-all-branch-by-delivery-point/${idBranch}`
        );
    },

    getDayAttentionByBranch(idBranch) {
        return ApiService.post(
            `/appointment/get-day-attention-by-branch/${idBranch}`
        );
    },

    getCalendarAppointment(idBranch, deliveryDate) {
        return ApiService.post(
            `/appointment/get-shifts-by-delivey-point/${idBranch}/day/${deliveryDate}`
        );
    },

    saveSchedulingAppointment(data) {
        return ApiService.post(`/order-appointment/scheduling`, data);
    },

    getAppointment(page, perPage) {
        return ApiService.get(`/order-appointment?page=${page}&perPage=${perPage}`);
    },

    cancelAppointment(idOrder, data) {
        return ApiService.post(
            `/order-appointment?idOrderAppointment=${idOrder}`,
            data
        );
    },

    attended(idOrder, data) {
        return ApiService.post(
            `/order-appointment/delivered/?idOrderAppointment=${idOrder}`,
            data
        );
    },

    getSetDates(idBranch) {
        return ApiService.get(
            `/appointment/get-dates-delivery-point/idBranch/${idBranch}`
        );
    },

    Active(data) {
        return ApiService.post(`/appointment/active`, data);
    },

    inActive(data) {
        return ApiService.post(`/appointment/inactive`, data);
    }
};
export default appointmentService;